module.exports = __webpack_public_path__ + "img/ibiki.f20d31b5.webp";